import { useContext } from "react";

import { ScoutConversationControllerContext } from "./scoutConversationControllerContext";

export function useScoutConversationController() {
  const controller = useContext(ScoutConversationControllerContext);
  if (!controller) {
    throw new Error(
      "useScoutConversation must be used within ScoutConversationControllerProvider."
    );
  }

  return controller;
}
